import React from "react";
import { useAppSelector } from "../../../redux/store";

const BankTransfers = () => {
  const booking = useAppSelector((state) => state.booking);
  const isAgency = booking.isAgencyBooking;
  const payments = booking.payment;

  return (
    <div className="col-12">
      {!isAgency && payments.immediatelyPayments.length > 0 && (
        <table className="table">
          <thead>
            <tr>
              <th>SOFORT-Überweisung</th>
              <th></th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            {payments.immediatelyPayments.map((item, index: any) => {
              return (
                <tr key={index}>
                  <td>{item.lastStatusDate == " " ? "--.--.----" : item.lastStatusDate}</td>
                  <td>{item.payAmount}</td>
                  <td>
                    {item.link != null ? (
                      <a href={item.link}>{item.transaction}</a>
                    ) : (
                      item.transaction
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default BankTransfers;
